<template>
	<vs-row v-if="capacityCreatePermission">
		<div class="vx-col w-full mb-base">
			<CapacityForm :dataCapacity="capacityItem" :isEditActive="false" />
		</div>
	</vs-row>
	<not-permission v-else></not-permission>
</template>
<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import CapacityForm from "./CapacityForm.vue";

export default {
	name: "Company",
	components: {
		NotPermission,
		CapacityForm,
	},
	data() {
		return {
			capacityItem: {},
			show: false,
		};
	},
	computed: {
		capacityCreatePermission() {
			return this.$store.getters.checkPermission("CAPACITY_C");
		},
	},
	mounted() {
		this.show = true;
	},
};
</script>
